import React from 'react';
import { Button } from '../../primitives/Button';
import { EntryPanel } from './EntryPanel';
import { EntryBuildStatus } from './EntryBuildStatus';

interface ServerSelectScreenProps { onNext: () => void }

/** The current application has one configured destination, not a selectable realm list. */
export const ServerSelectScreen: React.FC<ServerSelectScreenProps> = ({ onNext }) => (
  <EntryPanel label="Continue to character selection" actions={<Button variant="brass" size="lg" fullWidth onClick={onNext}>Choose your hero</Button>}>
    <h1>Your journey continues</h1>
    <p className="entry-screen__lead">Choose your hero next. Their saved journey will guide your return to the world.</p>
    <div className="entry-screen__well">
      <div className="entry-screen__label">Current destination</div>
      <h2>Helix 2000</h2>
      <p>{typeof window === 'undefined' ? 'This game server' : window.location.hostname}</p>
      <p className="entry-screen__note">The game connection is established when you enter the world.</p>
    </div>
    <div className="entry-screen__build"><EntryBuildStatus /></div>
  </EntryPanel>
);
